<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :product-id="productId"
            :runtimes="runtimes"
            :runtime-default="runtimeDefault"
            :is-addon="true"
            :market-regions="marketRegions"
            :target-options="targetOptions"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/ProductPlans/Form'

import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default () {
            return {}
        }
    },
    productId: {
        type: Number,
        default: 0
    },
    runtimes: {
        type: Array,
        default () {
            return []
        }
    },
    runtimeDefault: {
        type: String,
        default () {
            return ''
        }
    },
    marketRegions: {
        type: Array,
        default () {
            return []
        }
    },
    targetOptions: {
        type: Array,
        default () {
            return []
        }
    }
})

function submitData (form) {
    form.post(
        route('products.product-addons.products.plans.store', { product: props.productId })
    )
}
</script>
